import styled from 'styled-components';

import { Card } from 'components/ui';

export const MapCard = styled(Card)<{ $height?: number; $fallbackHeight: string }>`
  width: 100%;
  height: ${({ $height, $fallbackHeight }) => ($height ? `${$height}px` : $fallbackHeight)};

  .ant-card-body {
    height: 100%;
    padding: 0;
  }
`;

export const LoadingBadge = styled.div`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  display: flex;
  align-items: center;
  pointer-events: none;
  filter: drop-shadow(0 1px 2px ${({ theme }) => theme.darkShadow});
  gap: 12px;
  color: ${({ theme }) => theme.measurementTextColor};
  font-size: 32px;
  font-weight: 700;
`;

export const MapWrapper = styled.div`
  position: relative;
  height: 100%;

  .inspection-thumbnail {
    border: 2px solid ${({ theme }) => theme.borderAccentColor};
    border-radius: 4px;
    box-shadow: 0 2px 6px ${({ theme }) => theme.lightShadow};
  }

  .inspection-thumbnail.is-hovered {
    border-color: ${({ theme }) => theme.contrastColor};
  }

  .asset-map-label {
    font-size: 20px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 12px;
    background: ${({ theme }) => theme.tooltipBackground};
    color: ${({ theme }) => theme.measurementTextColor};
    border: 1px solid ${({ theme }) => theme.measurementTextBorder};
    box-shadow: 0 2px 6px ${({ theme }) => theme.measurementTextBoxShadow};
  }

  .leaflet-tooltip.damage-map-label {
    padding: 0;
    border-radius: 8px;
    white-space: normal;
    max-width: 360px;

    .leaflet-tooltip-content {
      margin: 0;
      padding: 8px 10px;
      font-size: 14px;
      line-height: 1.4;
      font-weight: 400;
      color: inherit;
    }

    .leaflet-tooltip-content,
    .leaflet-tooltip-content * {
      color: inherit;
    }

    b {
      font-weight: 600;
    }
  }
`;

export const MapPane = styled.div`
  position: relative;
  height: 100%;
`;

export const MapLegend = styled.div`
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 1500;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 10px;
  background: ${({ theme }) => theme.tooltipBackground};
  color: ${({ theme }) => theme.measurementTextColor};
  border: 1px solid ${({ theme }) => theme.measurementTextBorder};
  box-shadow: 0 2px 8px ${({ theme }) => theme.measurementTextBoxShadow};
  font-size: 14px;
  font-weight: 600;
`;

export const MapLegendRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MapLegendSwatch = styled.span<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background: ${({ $color }) => $color};
  box-shadow: 0 0 0 1px ${({ theme }) => theme.measurementTextBorder};
`;

export const MapLegendSwatchStriped = styled(MapLegendSwatch)<{ $color: string }>`
  background: transparent;
  border: 2px dotted ${({ $color }) => $color};
  box-shadow: none;
`;
